import React, { useState, useEffect } from 'react';
import '../../../styles/dashboardPagesStyle/Charts.css';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { Info } from 'lucide-react';
import { getContagemEmpreendimentoPorTipo } from '../../../API/dashboardPageService';

interface ProdutoDataItem {
  name: string;
  value: number;
}

const cores: string[] = ['#29306A', '#F55EEB', '#32BEF0', '#1323adff', '#4F65D6'];

// Função para exibir o label externo com porcentagem
const renderCustomizedLabel = (props: any) => {
  const RADIAN = Math.PI / 180;
  const { cx, cy, midAngle, outerRadius, percent } = props;
  
  const radius = outerRadius + 20; 
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y + 2}
      fill="#29306A"
      fontWeight="bold"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
      fontSize={12}
    >
      {`${(percent * 100).toFixed(1)}%`}
    </text>
  );
};

export default function EstoqueProdutoChart() {
  const [popup, setPopup] = useState<{ visible: boolean; text: string }>({
    visible: false,
    text: '',
  });

  const [produtoData, setProdutoData] = useState<ProdutoDataItem[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getContagemEmpreendimentoPorTipo();
        const formattedData: ProdutoDataItem[] = Object.entries(data).map(([key, value]) => ({
          name: key,
          value: value,
        }));
        setProdutoData(formattedData);
      } catch (error) {
        console.error('Erro ao carregar dados do gráfico:', error);
      }
    };

    fetchData();
  }, []);

  const handleInfoClick = () => {
    setPopup({
      visible: true,
      text: 'Este gráfico mostra a distribuição do estoque por tipo de produto, com porcentagem de cada categoria em relação ao total.',
    });
  };

  const fecharPopup = () => setPopup({ visible: false, text: '' });

  return (
    <div className="card-grafico-produto info-card">
      <h3>Estoque por tipo de produto</h3>
      <Info className="info-btn" size={20} onClick={handleInfoClick} />

      <ResponsiveContainer width="100%" height={220}>
        <PieChart>
          <Pie
            data={produtoData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            innerRadius={40}
            outerRadius={60}
            labelLine={true}
            label={renderCustomizedLabel}
          >
            {produtoData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={cores[index % cores.length]} />
            ))}
          </Pie>
          <Legend verticalAlign="bottom" height={30} iconType="circle" />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>

      {popup.visible && (
        <div className="info-popup-overlay" onClick={fecharPopup}>
          <div className="info-popup" onClick={e => e.stopPropagation()}>
            <h4>Informações</h4>
            <p>{popup.text}</p>
            <button onClick={fecharPopup}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
}
